import { render, staticRenderFns } from "./VoidInvoices.vue?vue&type=template&id=6e750fc6&"
import script from "./VoidInvoices.vue?vue&type=script&lang=ts&"
export * from "./VoidInvoices.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports